import { Form, Input } from "antd";
import React from "react";
import { LOGGER } from "../../../helpers/logger";
import { resetPassword } from "aws-amplify/auth";
import { SET_LOCAL_STORAGE } from "../../../helpers/localStorage";
function ForgotPassword({ nextPage }) {
  async function handleResetPassword(email) {
    try {
      const output = await resetPassword({ username: email });
      handleResetPasswordNextSteps(output, email);
    } catch (error) {
      console.log(error);
    }
  }

  function handleResetPasswordNextSteps(output, email) {
    const { nextStep } = output;
    switch (nextStep.resetPasswordStep) {
      case "CONFIRM_RESET_PASSWORD_WITH_CODE":
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        SET_LOCAL_STORAGE("email", email);
        LOGGER(
          `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
        );
        // Collect the confirmation code from the user and pass to confirmResetPassword.
        break;
      case "DONE":
        LOGGER("Successfully reset password.");
        break;
    }
  }

  const onFinish = (values) => {
    LOGGER("val:", values);
    handleResetPassword(values.email);
    nextPage();
  };
  const onFinishFailed = (errorInfo) => {
    LOGGER("Failed:", errorInfo);
  };
  return (
    <div>
      <h1 className="mb-3 font-medium  text-[16px]">Forgot Password</h1>

      <Form
        name="basic"
        layout="vertical"
        requiredMark={false}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label={<p className="text-[14px] text-[#626476]">Email</p>}
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please enter your email!",
            },
          ]}
        >
          <Input
            autoComplete="off"
            className="py-[10px] px-[10px] "
          />
        </Form.Item>

        <button
          type="submit"
          className="w-[100%] rounded-[5px] text-[13px] font-medium text-white py-[10px] bg-[#005EB8]"
        >
          Submit
        </button>
      </Form>
    </div>
  );
}

export default ForgotPassword;
